import {
  Text,
  Modal,
  Button,
  ModalBody,
  ModalContent,
  ModalFooter,
} from "@wootingkb/component-library";
import { useState } from "react";
import { RoleReward } from "../../../../utils/constants/types";
import Confetti from "../Confetti";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";

const MODAL_CLOSE_MESSAGES = [
  msg({ id: "Discord_modal_close_cool", message: "Cool" }),
  msg({ id: "Discord_modal_close_sweet", message: "Sweet" }),
  msg({ id: "Discord_modal_close_alright", message: "Alright" }),
  msg({ id: "Discord_modal_close_great", message: "Great" }),
  msg({ id: "Discord_modal_close_awesome", message: "Awesome" }),
];

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onOpenChange: (open: boolean) => void;
  newRoles: RoleReward[];
}

export default function RewardsModal({
  isOpen,
  onClose,
  onOpenChange,
  newRoles,
}: Props) {
  const { _: i18n } = useLingui();
  const [messageIndex] = useState(() =>
    Math.floor(Math.random() * MODAL_CLOSE_MESSAGES.length)
  );
  const buttonTitle = i18n(MODAL_CLOSE_MESSAGES[messageIndex]);

  return (
    <>
      <Confetti />
      <Modal open={isOpen} onOpenChange={onOpenChange}>
        <ModalContent className="max-h-full overflow-y-auto md:max-h-[90vh]">
          <ModalBody
            title={
              <Trans id="Discord_rewards_modal_title">Rewards received!</Trans>
            }
          >
            <Text>
              <Trans id="Discord_rewards_modal_body">
                You've been awarded the following rewards!
              </Trans>
            </Text>

            <ul className="list-inside list-disc pl-4">
              {newRoles.map((role) => (
                <li key={role.roleId}>{role.rewardName}</li>
              ))}
            </ul>
          </ModalBody>

          <ModalFooter className="flex justify-end">
            <Button variant="secondary" size="sm" onClick={onClose}>
              {buttonTitle}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
